import { find as _find } from 'lodash';
import { get, put, post } from './fetch'

export const getAllCategories = () => {
  return get(`/api/categories`, false);
}

export const getCategoryBySEOName = (seoName) => {
  return get(`/api/categories/${seoName}`, false);
}

export const getAllCategoriesWithServices = () => {
  return new Promise(resolve => {
    get('/api/categories', false).then(({ data }) => {
      Promise.all(data.map(cat => get(`/api/categories/${cat.categoryID}/services`, false))).then(service => {
        resolve(data.map((cat, index) => ({
          ...cat,
          services: service[index].data
        })))
      })
    })
  })
}

export const getCategoryList = () => {
  return get(`/api/categories/list/all`, true);
}